import {RemovalZonesList} from './RemovalZonesList'

export const RemovalZonesListPage = RemovalZonesList;